import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import './ClientDetail.css';

function ClientDetail() {
  const { id } = useParams();
  const [client, setClient] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [verifying, setVerifying] = useState(false);
  const navigate = useNavigate();

  const loadClient = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`/api/clients/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setClient(response.data.client);
    } catch (err) {
      setError(err.response?.data?.error || err.response?.data?.message || 'Failed to load client.');
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    loadClient();
  }, [loadClient]);

  const markVerified = async () => {
    try {
      setVerifying(true);
      setError('');
      setMessage('');
      const token = localStorage.getItem('token');
      const response = await axios.post(`/api/clients/${id}/mark-email-verified`, {}, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setMessage(response.data.message || 'Client email marked as verified.');
      await loadClient();
    } catch (err) {
      setError(err.response?.data?.error || err.response?.data?.message || 'Failed to mark email verified.');
    } finally {
      setVerifying(false);
    }
  };

  return (
    <div className="client-detail-page">
      <button className="back-link" onClick={() => navigate('/clients')}>
        Client Detail
      </button>
      <div className="client-detail-card">
        {loading ? (
          <div className="detail-loading">Loading client...</div>
        ) : error ? (
          <div className="detail-error">{error}</div>
        ) : (
          client && (
            <>
              <div className="detail-header">
                <div>
                  <h2>{client.ClientName}</h2>
                  <p>{client.Email || 'No email provided'}</p>
                </div>
                <div className="detail-header-actions">
                  <div className="detail-phone">{client.DriverPhone || client.Phone}</div>
                  {!client.EmailVerified && client.AppUsername ? (
                    <button className="detail-verify-btn" onClick={markVerified} disabled={verifying}>
                      {verifying ? 'Verifying...' : 'Mark Verified'}
                    </button>
                  ) : null}
                </div>
              </div>

              {message ? <div className="detail-success">{message}</div> : null}

              <div className="detail-grid">
                <div>
                  <h4>Phone</h4>
                  <p>{client.Phone || '-'}</p>
                </div>
                <div>
                  <h4>Driver Phone</h4>
                  <p>{client.DriverPhone || '-'}</p>
                </div>
                <div>
                  <h4>City</h4>
                  <p>{client.City || '-'}</p>
                </div>
                <div>
                  <h4>Zip Code</h4>
                  <p>{client.ZipCode || '-'}</p>
                </div>
                <div>
                  <h4>Customer App</h4>
                  <p>{client.MobileAccessEnabled ? 'Enabled' : 'Disabled'}</p>
                </div>
                <div>
                  <h4>Email Verification</h4>
                  <p>{client.EmailVerified ? `Verified${client.EmailVerifiedAt ? ` on ${new Date(client.EmailVerifiedAt).toLocaleDateString()}` : ''}` : 'Pending'}</p>
                </div>
                <div className="detail-address">
                  <h4>Address</h4>
                  <p>{client.Address || '-'}</p>
                </div>
              </div>
            </>
          )
        )}
      </div>
    </div>
  );
}

export default ClientDetail;
